/* ============================================================
   SIMOVO — Destinations discovery controller
   Vanilla port of the approved React prototype (app.jsx + catalog.js).
   - Fetches the collection's own products.json (stays in sync with admin).
   - Builds: region chips, "browse by region" tiles, popular row,
     regional plans, per-continent grids, live search & sort.
   - No dependencies. Re-inits in the theme editor.
   Config is read from data-* attributes on the .svo-dest root.
   ============================================================ */
(function () {
  "use strict";

  /* ---------- region config ---------- */
  var regionOrder = ["Europe", "Asia", "Middle East", "Africa", "North America", "Caribbean", "South America", "Oceania"];
  var regionMeta = {
    "Europe":        { color: "#5b9bd5", blurb: "From city breaks to island escapes across the continent." },
    "Asia":          { color: "#f24f31", blurb: "Tokyo to Bali — coverage right across Asia." },
    "Middle East":   { color: "#c79a3b", blurb: "Gulf cities, ancient wonders and everywhere between." },
    "Africa":        { color: "#5bb98c", blurb: "Safari, souks and coastline — connected throughout." },
    "North America": { color: "#7b6cd9", blurb: "USA, Canada, Mexico and the wider region." },
    "Caribbean":     { color: "#3bb6c7", blurb: "Island-hop without losing signal." },
    "South America": { color: "#e8893b", blurb: "Patagonia to the Amazon, all on one eSIM." },
    "Oceania":       { color: "#d067a8", blurb: "Australia, New Zealand and the Pacific islands." }
  };
  var continentTags = {};
  regionOrder.forEach(function (r) { continentTags[r] = true; });

  var popularHandles = {};
  ["egypt","indonesia","japan","morocco","south-korea","thailand","turkey",
   "united-kingdom","united-states","spain","italy","france","vietnam","australia"]
    .forEach(function (h) { popularHandles[h] = true; });

  /* country/territory name -> ISO 3166-1 alpha-2 (for flags) */
  var NAME_CC = {
    "albania":"al","aland islands":"ax","andorra":"ad","austria":"at","belarus":"by","belgium":"be","bosnia and herzegovina":"ba","bosnia":"ba","bulgaria":"bg","croatia":"hr","cyprus":"cy","czechia":"cz","czech republic":"cz","denmark":"dk","estonia":"ee","faroe islands":"fo","finland":"fi","france":"fr","germany":"de","gibraltar":"gi","greece":"gr","guernsey":"gg","hungary":"hu","iceland":"is","ireland":"ie","isle of man":"im","italy":"it","jersey":"je","kosovo":"xk","latvia":"lv","liechtenstein":"li","lithuania":"lt","luxembourg":"lu","malta":"mt","moldova":"md","monaco":"mc","montenegro":"me","netherlands":"nl","north macedonia":"mk","macedonia":"mk","norway":"no","poland":"pl","portugal":"pt","romania":"ro","russia":"ru","san marino":"sm","serbia":"rs","slovakia":"sk","slovenia":"si","spain":"es","sweden":"se","switzerland":"ch","ukraine":"ua","united kingdom":"gb","uk":"gb","vatican city":"va",
    "afghanistan":"af","bangladesh":"bd","bali":"id","bhutan":"bt","brunei":"bn","cambodia":"kh","china":"cn","hong kong":"hk","india":"in","indonesia":"id","japan":"jp","kazakhstan":"kz","kyrgyzstan":"kg","laos":"la","macao":"mo","macau":"mo","malaysia":"my","maldives":"mv","mongolia":"mn","myanmar":"mm","nepal":"np","pakistan":"pk","philippines":"ph","singapore":"sg","south korea":"kr","sri lanka":"lk","taiwan":"tw","tajikistan":"tj","thailand":"th","turkmenistan":"tm","uzbekistan":"uz","vietnam":"vn",
    "armenia":"am","azerbaijan":"az","bahrain":"bh","georgia":"ge","iran":"ir","iraq":"iq","israel":"il","jordan":"jo","kuwait":"kw","lebanon":"lb","oman":"om","palestine":"ps","qatar":"qa","saudi arabia":"sa","syria":"sy","turkey":"tr","turkiye":"tr","united arab emirates":"ae","uae":"ae","yemen":"ye",
    "algeria":"dz","angola":"ao","benin":"bj","botswana":"bw","burkina faso":"bf","burundi":"bi","cameroon":"cm","cape verde":"cv","central african republic":"cf","chad":"td","comoros":"km","congo":"cg","democratic republic of the congo":"cd","ivory coast":"ci","cote d'ivoire":"ci","djibouti":"dj","egypt":"eg","equatorial guinea":"gq","eritrea":"er","eswatini":"sz","ethiopia":"et","gabon":"ga","gambia":"gm","ghana":"gh","guinea":"gn","guinea-bissau":"gw","kenya":"ke","lesotho":"ls","liberia":"lr","libya":"ly","madagascar":"mg","malawi":"mw","mali":"ml","mauritania":"mr","mauritius":"mu","morocco":"ma","mozambique":"mz","namibia":"na","niger":"ne","nigeria":"ng","rwanda":"rw","sao tome and principe":"st","senegal":"sn","seychelles":"sc","sierra leone":"sl","somalia":"so","south africa":"za","south sudan":"ss","sudan":"sd","tanzania":"tz","togo":"tg","tunisia":"tn","uganda":"ug","zambia":"zm","zimbabwe":"zw","reunion":"re","cabo verde":"cv",
    "canada":"ca","mexico":"mx","united states":"us","usa":"us","greenland":"gl","bermuda":"bm",
    "belize":"bz","costa rica":"cr","el salvador":"sv","guatemala":"gt","honduras":"hn","nicaragua":"ni","panama":"pa",
    "anguilla":"ai","antigua and barbuda":"ag","aruba":"aw","bahamas":"bs","barbados":"bb","british virgin islands":"vg","cayman islands":"ky","cuba":"cu","curacao":"cw","dominica":"dm","dominican republic":"do","grenada":"gd","guadeloupe":"gp","haiti":"ht","jamaica":"jm","martinique":"mq","montserrat":"ms","puerto rico":"pr","saint kitts and nevis":"kn","saint lucia":"lc","saint vincent and the grenadines":"vc","sint maarten":"sx","trinidad and tobago":"tt","turks and caicos islands":"tc","us virgin islands":"vi",
    "argentina":"ar","bolivia":"bo","brazil":"br","chile":"cl","colombia":"co","ecuador":"ec","french guiana":"gf","guyana":"gy","paraguay":"py","peru":"pe","suriname":"sr","uruguay":"uy","venezuela":"ve",
    "australia":"au","fiji":"fj","french polynesia":"pf","kiribati":"ki","new caledonia":"nc","new zealand":"nz","papua new guinea":"pg","samoa":"ws","solomon islands":"sb","tonga":"to","vanuatu":"vu"
  };

  var flagFor = function (cc) { return cc ? "https://flagcdn.com/w160/" + cc + ".png" : null; };

  /* ---------- parser (from catalog.js) ---------- */
  function normName(title) {
    return (title || "")
      .replace(/^buy a (multi country )?travel esim for /i, "")
      .replace(/^esim for /i, "")
      .replace(/\s*esim.*$/i, "")
      .replace(/\s*with unlimited.*$/i, "")
      .replace(/[\u2019']/g, "'")
      .trim();
  }
  function displayName(title) {
    var n = normName(title);
    if (!n) n = (title || "").replace(/\s*esim\s*$/i, "").trim();
    return n;
  }
  function ccFor(title) { return NAME_CC[normName(title).toLowerCase()] || null; }
  function minPrice(p) {
    var prices = (p.variants || []).map(function (v) { return parseFloat(v.price); })
      .filter(function (n) { return !isNaN(n) && n > 0; });
    return prices.length ? Math.min.apply(null, prices) : null;
  }
  function imageOf(p) {
    if (p.images && p.images[0] && p.images[0].src) return p.images[0].src;
    var v = (p.variants || []).filter(function (v) { return v.featured_image && v.featured_image.src; })[0];
    return v ? v.featured_image.src : null;
  }
  function regionOf(p) {
    var tags = (p.tags || []).map(function (t) { return String(t).trim(); });
    for (var i = 0; i < tags.length; i++) { if (continentTags[tags[i]]) return tags[i]; }
    return null;
  }
  function isRegional(p) {
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
    return tags.indexOf("multicountry") > -1 || tags.indexOf("multi-country") > -1 || tags.indexOf("region") > -1;
  }
  function parse(products) {
    var countries = [], regionals = [];
    (products || []).forEach(function (p) {
      var price = minPrice(p);
      if (price == null) return;
      var base = { name: displayName(p.title), handle: p.handle, price: price, img: imageOf(p), region: regionOf(p) };
      if (isRegional(p)) {
        regionals.push(Object.assign({}, base, { count: "Multi-country" }));
      } else {
        base.cc = ccFor(p.title);
        base.popular = !!popularHandles[p.handle];
        if (!base.region) base.region = "Other";
        countries.push(base);
      }
    });
    regionals.sort(function (a, b) { return a.price - b.price; });
    return { countries: countries, regionals: regionals };
  }

  /* Collection-based parsing: treat a whole feed as countries or as regionals,
     no tag dependency (SIMOVO splits by collection, not by a multicountry tag). */
  function asCountry(p) {
    var price = minPrice(p); if (price == null) return null;
    return { name: displayName(p.title), handle: p.handle, price: price, img: imageOf(p),
             region: regionOf(p) || "Other", cc: ccFor(p.title), popular: !!popularHandles[p.handle] };
  }
  function asRegional(p) {
    var price = minPrice(p); if (price == null) return null;
    return { name: displayName(p.title), handle: p.handle, price: price, img: imageOf(p),
             region: regionOf(p), count: "Multi-country" };
  }
  function parseCollections(countryFeed, regionalFeed) {
    var regionals = [], regHandles = {};
    (regionalFeed || []).forEach(function (p) { var r = asRegional(p); if (r) { regionals.push(r); regHandles[r.handle] = true; } });
    var countries = [];
    (countryFeed || []).forEach(function (p) {
      if (regHandles[p.handle]) return;          // dedupe: lives in the regional feed
      if (isRegional(p)) { if (!regHandles[p.handle]) { var rr = asRegional(p); if (rr) { regionals.push(rr); regHandles[rr.handle] = true; } } return; }
      var c = asCountry(p); if (c) countries.push(c);
    });
    regionals.sort(function (a, b) { return a.price - b.price; });
    return { countries: countries, regionals: regionals };
  }

  /* ---------- sort ---------- */
  function sortItems(arr, sort) {
    var a = arr.slice();
    switch (sort) {
      case "price-asc":  return a.sort(function (x, y) { return x.price - y.price; });
      case "price-desc": return a.sort(function (x, y) { return y.price - x.price; });
      case "az":         return a.sort(function (x, y) { return x.name.localeCompare(y.name); });
      case "za":         return a.sort(function (x, y) { return y.name.localeCompare(x.name); });
      default:           return a.sort(function (x, y) { return ((y.popular === true) - (x.popular === true)) || x.name.localeCompare(y.name); });
    }
  }

  /* ---------- colour + money helpers ---------- */
  function hexToRgb(h) { h = h.replace("#", ""); if (h.length === 3) h = h.split("").map(function (c) { return c + c; }).join(""); var n = parseInt(h, 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
  function rgbToHex(r, g, b) { return "#" + [r, g, b].map(function (v) { return Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, "0"); }).join(""); }
  function shade(hex, amt) { var c = hexToRgb(hex); var f = amt < 0 ? 1 + amt : 1; return rgbToHex(c[0] * f, c[1] * f, c[2] * f); }
  function tint(hex, amt) { var c = hexToRgb(hex); return rgbToHex(c[0] + (255 - c[0]) * amt, c[1] + (255 - c[1]) * amt, c[2] + (255 - c[2]) * amt); }

  function makeMoney(format) {
    // Shopify-style money formatter. price = decimal in shop currency (e.g. 3 or 3.5).
    function fmt(cents, fmtStr) {
      function dp(num, precision, thousands, decimal) {
        num = (num / 100).toFixed(precision);
        var parts = num.split(".");
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
        var cents = parts[1] ? decimal + parts[1] : "";
        return dollars + cents;
      }
      var value = "";
      var placeholder = (fmtStr.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || "amount";
      switch (placeholder) {
        case "amount": value = dp(cents, 2, ",", "."); break;
        case "amount_no_decimals": value = dp(cents, 0, ",", "."); break;
        case "amount_with_comma_separator": value = dp(cents, 2, ".", ","); break;
        case "amount_no_decimals_with_comma_separator": value = dp(cents, 0, ".", ","); break;
        case "amount_with_space_separator": value = dp(cents, 2, " ", ","); break;
        case "amount_no_decimals_with_space_separator": value = dp(cents, 0, " ", ""); break;
        case "amount_with_apostrophe_separator": value = dp(cents, 2, "'", "."); break;
        default: value = dp(cents, 2, ",", ".");
      }
      return fmtStr.replace(/\{\{\s*\w+\s*\}\}/, value);
    }
    return function (price) {
      if (price <= 0) return "Free";
      var f = format || "${{amount}}";
      return fmt(Math.round(price * 100), f);
    };
  }

  /* ---------- icons ---------- */
  var ICON = {
    search: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2"/><path d="m20 20-3.2-3.2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    arrow: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M5 12h14m-6-6 6 6-6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    arrowSm: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M5 12h14m-6-6 6 6-6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    heart: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 20s-7-4.3-9.3-8.6C1.2 8.5 2.6 5.5 5.6 5.1 7.7 4.8 9.3 6 12 8.7 14.7 6 16.3 4.8 18.4 5.1c3 .4 4.4 3.4 2.9 6.3C19 15.7 12 20 12 20Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>',
    heartFill: '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style="color:var(--accent)"><path d="M12 20s-7-4.3-9.3-8.6C1.2 8.5 2.6 5.5 5.6 5.1 7.7 4.8 9.3 6 12 8.7 14.7 6 16.3 4.8 18.4 5.1c3 .4 4.4 3.4 2.9 6.3C19 15.7 12 20 12 20Z"/></svg>',
    globe: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/><path d="M3 12h18M12 3c2.5 2.5 2.5 15 0 18M12 3c-2.5 2.5-2.5 15 0 18" stroke="currentColor" stroke-width="1.8"/></svg>'
  };

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]; }); }
  function regionTint(region) { var c = (regionMeta[region] && regionMeta[region].color) || "#8d8073"; return "linear-gradient(135deg, " + c + ", " + c + "cc)"; }

  /* ============================================================
     Per-instance controller
     ============================================================ */
  function init(root) {
    if (!root || root.__svoInit) return;
    root.__svoInit = true;

    var cfg = {
      productsUrl: root.getAttribute("data-products-url") || "/collections/all/products.json?limit=250",
      countriesUrl: root.getAttribute("data-countries-url") || "",
      regionalUrl:  root.getAttribute("data-regional-url") || "",
      cardStyle:   root.getAttribute("data-card-style") || "photo",
      showTiles:   root.getAttribute("data-show-tiles") !== "false",
      showPopular: root.getAttribute("data-show-popular") !== "false",
      showRegional:root.getAttribute("data-show-regional") !== "false",
      moneyFormat: root.getAttribute("data-money-format") || "${{amount}}",
      scope:       (root.getAttribute("data-svo-scope") || "").trim(),
      colTitle:    (root.getAttribute("data-collection-title") || "").trim()
    };
    var money = makeMoney(cfg.moneyFormat);
    var prodUrl = function (h) { return "/products/" + h; };
    var imgOrFlag = function (c) { return c.img || flagFor(c.cc); };

    // derive accent shades from the root's --accent
    var accent = getComputedStyle(root).getPropertyValue("--accent").trim() || "#f24f31";
    try {
      root.style.setProperty("--accent-ink", shade(accent, -0.22));
      root.style.setProperty("--accent-soft", tint(accent, 0.84));
    } catch (e) {}

    var app = root.querySelector("[data-svo-app]");
    var chipsBox = root.querySelector("[data-svo-chips]");
    var regionSel = root.querySelector("[data-svo-region-select]");
    var sortSel = root.querySelector("[data-svo-sort]");
    var searchInputs = Array.prototype.slice.call(root.querySelectorAll("[data-svo-search]"));
    var fallback = root.querySelector("[data-svo-fallback]");

    var scoped = (cfg.scope && regionMeta[cfg.scope]) ? cfg.scope : null;
    var state = { data: null, query: "", region: scoped || "all", sort: "featured", favs: {}, scoped: scoped };

    /* ---------- card builders ---------- */
    function countryCard(c) {
      var fav = !!state.favs[c.handle];
      if (cfg.cardStyle === "compact") {
        return '<a class="row" href="' + prodUrl(c.handle) + '">' +
          (c.cc ? '<img class="rflag" src="' + flagFor(c.cc) + '" alt="" loading="lazy">' : '<span class="rflag rflag-x">' + esc(c.name[0]) + '</span>') +
          '<div class="rname">' + esc(c.name) + '<span class="rreg">' + esc(c.region) + '</span></div>' +
          '<div class="rprice"><span class="from">from </span><b>' + money(c.price) + '</b></div>' +
          '<span class="radd" title="View plans">' + ICON.arrow + '</span></a>';
      }
      if (cfg.cardStyle === "flag") {
        return '<a class="ftile" href="' + prodUrl(c.handle) + '">' +
          (c.cc ? '<img class="fbig" src="' + flagFor(c.cc) + '" alt="" loading="lazy">' : '<span class="fbig fbig-x">' + esc(c.name.slice(0, 2).toUpperCase()) + '</span>') +
          '<div class="fname">' + esc(c.name) + '</div>' +
          '<div class="fprice">from <b>' + money(c.price) + '</b></div>' +
          '<span class="fadd">View plans</span></a>';
      }
      // photo (default)
      var media = c.img
        ? '<img src="' + c.img + '" alt="' + esc(c.name) + '" loading="lazy" onerror="this.style.display=\'none\'">'
        : '<div class="ph-fallback" style="background:' + regionTint(c.region) + '">' + (c.cc ? '<img src="' + flagFor(c.cc) + '" alt="" class="ph-flag-lg" loading="lazy">' : '') + '</div>';
      return '<a class="card" href="' + prodUrl(c.handle) + '">' +
        '<div class="ph">' + media +
          (c.cc ? '<img class="flagtag" src="' + flagFor(c.cc) + '" alt="" loading="lazy">' : '') +
          '<button class="heart" type="button" title="Save" data-fav="' + esc(c.handle) + '">' + (fav ? ICON.heartFill : ICON.heart) + '</button>' +
          '<span class="tag-unl">Unlimited data</span>' +
        '</div>' +
        '<div class="body"><div class="nm">' + esc(c.name) + '</div>' +
          '<div class="meta"><div class="price"><span class="from">from </span><b>' + money(c.price) + '</b></div>' +
          '<span class="qadd">View plans ' + ICON.arrow + '</span></div></div></a>';
    }

    function regionalCard(r) {
      var blurb = (regionMeta[r.region] && regionMeta[r.region].blurb) || "One eSIM across multiple countries — no swapping.";
      var bg = r.img ? '<img class="bg" src="' + r.img + '" alt="' + esc(r.name) + '" loading="lazy">' : '<div class="bg" style="background:' + regionTint(r.region) + '"></div>';
      return '<a class="rcard" href="' + prodUrl(r.handle) + '">' + bg + '<div class="scrim"></div>' +
        '<div class="rc-top">' + ICON.globe + ' ' + esc(r.count || "Multi-country") + '</div>' +
        '<div class="rc-body"><h3>' + esc(r.name) + '</h3>' +
        '<div class="rc-blurb">' + esc(blurb) + '</div>' +
        '<div class="rc-foot"><div class="rc-price">from <b>' + money(r.price) + '</b></div>' +
        '<span class="rc-cta">View plans ' + ICON.arrow + '</span></div></div></a>';
    }

    function gridClass() { return cfg.cardStyle === "compact" ? "grid compact" : cfg.cardStyle === "flag" ? "grid flagtile" : "grid"; }
    function countryGrid(items) { return '<div class="' + gridClass() + '">' + items.map(countryCard).join("") + '</div>'; }

    function secHead(kicker, title, sub, right, color) {
      return '<div class="sec-head"><div>' +
        '<div class="kicker"' + (color ? ' style="color:' + color + '"' : '') + '>' + esc(kicker) + '</div>' +
        '<h2>' + esc(title) + '</h2>' + (sub ? '<p>' + esc(sub) + '</p>' : '') + '</div>' +
        (right != null ? '<div class="right">' + esc(right) + '</div>' : '') + '</div>';
    }

    /* ---------- derived data ---------- */
    function derived() {
      var countries = state.data.countries, regionals = state.data.regionals;
      var set = {}; countries.forEach(function (c) { set[c.region] = true; });
      var ordered = regionOrder.filter(function (r) { return set[r]; });
      var extras = Object.keys(set).filter(function (r) { return regionOrder.indexOf(r) < 0; });
      var regionsPresent = ordered.concat(extras);
      var byRegion = {}; countries.forEach(function (c) { (byRegion[c.region] = byRegion[c.region] || []).push(c); });
      var popular = sortItems(countries.filter(function (c) { return c.popular; }), state.sort);
      return { countries: countries, regionals: regionals, regionsPresent: regionsPresent, byRegion: byRegion, popular: popular };
    }

    /* ---------- chips (sticky bar) ---------- */
    function renderChips(d) {
      if (state.scoped) { if (chipsBox) chipsBox.innerHTML = ""; if (regionSel) regionSel.innerHTML = ""; return; }
      var total = d.countries.length + d.regionals.length;
      var chips = [
        { id: "all", label: "All destinations", ct: total },
        { id: "popular", label: "Popular", ct: d.popular.length },
        { id: "regional", label: "Regional plans", ct: d.regionals.length }
      ].concat(d.regionsPresent.map(function (r) { return { id: r, label: r, ct: (d.byRegion[r] || []).length }; }));
      var searching = state.query.trim().length > 0;
      if (chipsBox) {
        chipsBox.innerHTML = chips.map(function (ch) {
          var on = !searching && state.region === ch.id;
          return '<button type="button" class="chip' + (on ? " active" : "") + '" data-region="' + esc(ch.id) + '">' +
            esc(ch.label) + ' <span class="ct">' + ch.ct + '</span></button>';
        }).join("");
      }
      if (regionSel) {
        regionSel.innerHTML = chips.map(function (ch) {
          return '<option value="' + esc(ch.id) + '">' + esc(ch.label) + ' (' + ch.ct + ')</option>';
        }).join("");
        regionSel.value = searching ? "all" : state.region;
      }
    }

    /* ---------- region tiles ---------- */
    function regionTiles(d) {
      if (!cfg.showTiles) return "";
      var tiles = d.regionsPresent.map(function (reg) {
        var list = d.byRegion[reg] || [];
        if (!list.length) return "";
        var from = Math.min.apply(null, list.map(function (c) { return c.price; }));
        var withImg = list.filter(function (c) { return c.img; })[0];
        var flags = list.filter(function (c) { return c.cc; }).slice(0, 5);
        var color = (regionMeta[reg] && regionMeta[reg].color) || "#8d8073";
        var on = state.region === reg;
        var media = withImg ? '<img src="' + withImg.img + '" alt="' + esc(reg) + '" loading="lazy">'
                            : '<div style="width:100%;height:100%;background:' + regionTint(reg) + '"></div>';
        var flagHtml = flags.map(function (c) { return '<img src="' + flagFor(c.cc) + '" alt="" loading="lazy">'; }).join("") +
          (list.length > flags.length ? '<span class="rtile-more">+' + (list.length - flags.length) + '</span>' : "");
        return '<button type="button" class="rtile' + (on ? " on" : "") + '" data-region="' + esc(reg) + '">' +
          '<div class="rtile-img">' + media + '<span class="rtile-scrim"></span>' +
          '<span class="rtile-count" style="background:' + color + '">' + list.length + '</span></div>' +
          '<div class="rtile-body"><div class="rtile-name">' + esc(reg) + '</div>' +
          '<div class="rtile-flags">' + flagHtml + '</div>' +
          '<div class="rtile-foot"><span class="rtile-from">from <b>' + money(from) + '</b></span>' +
          '<span class="rtile-go">View ' + ICON.arrowSm + '</span></div></div></button>';
      }).join("");
      return '<section class="block scroll-anchor"><div class="wrap">' +
        secHead("Browse by region", "Where in the world are you headed?",
                "Tap a region to see every destination in it — or search for a specific country above.", null) +
        '<div class="region-tiles">' + tiles + '</div></div></section>';
    }

    /* ---------- main render ---------- */
    function render() {
      var d = derived();
      renderChips(d);

      var q = state.query.trim().toLowerCase();
      var searching = q.length > 0;
      var matchQ = function (s) { return !q || String(s || "").toLowerCase().indexOf(q) > -1; };
      var html = "";

      // ----- Scoped (single-region "mini" page) -----
      if (state.scoped) {
        var R = state.scoped;
        var color = (regionMeta[R] && regionMeta[R].color) || "var(--accent-ink)";
        var cs = sortItems((d.byRegion[R] || []).filter(function (c) { return matchQ(c.name); }), state.sort);
        var rs = sortItems(d.regionals.filter(function (r) { return r.region === R && (matchQ(r.name) || matchQ(r.region)); }), state.sort);
        var inCount = cs.length + rs.length;

        // While searching, also look across every OTHER region so a query like
        // "Japan" on the Europe page still finds it (surfaced under "Beyond …").
        var ec = [], er = [];
        if (searching) {
          ec = sortItems(d.countries.filter(function (c) { return (matchQ(c.name) || matchQ(c.region)) && c.region !== R; }), state.sort);
          er = d.regionals.filter(function (r) { return (matchQ(r.name) || matchQ(r.region)) && r.region !== R; });
        }
        var elseCount = ec.length + er.length;

        html += '<div data-svo-grid-top></div>';
        html += '<section class="block"><div class="wrap">';
        html += secHead(R, cfg.colTitle || R,
          (regionMeta[R] && regionMeta[R].blurb) || null,
          searching ? null : (inCount + (inCount === 1 ? " plan" : " plans")), color);

        if (searching && inCount === 0 && elseCount === 0) {
          html += '<div class="empty">' + ICON.search +
            '<h3>No destinations match \u201c' + esc(state.query) + '\u201d.</h3>' +
            '<p>Try a country name like \u201cJapan\u201d, or clear your search.</p>' +
            '<button type="button" data-clear>Clear search</button></div>';
        } else if (searching && inCount === 0) {
          // nothing in this region, but matches exist elsewhere — show them
          html += '<p class="result-meta" style="padding-top:0;margin-bottom:14px">No ' + esc(R) + ' destinations match \u201c' + esc(state.query) + '\u201d \u2014 here\u2019s what we found in other regions:</p>';
          if (er.length) html += '<div class="rgrid" style="margin-bottom:30px">' + er.map(regionalCard).join("") + '</div>';
          if (ec.length) html += countryGrid(ec);
        } else {
          if (rs.length) html += '<div class="rgrid" style="margin-bottom:30px">' + rs.map(regionalCard).join("") + '</div>';
          if (cs.length) html += countryGrid(cs);
          if (searching && elseCount) {
            html += '<div class="sec-head" style="margin-top:38px"><div><div class="kicker" style="color:' + color + '">Beyond ' + esc(R) + '</div><h2>Also matching \u201c' + esc(state.query) + '\u201d</h2></div><div class="right">' + elseCount + (elseCount === 1 ? ' result' : ' results') + '</div></div>';
            if (er.length) html += '<div class="rgrid" style="margin-bottom:30px">' + er.map(regionalCard).join("") + '</div>';
            if (ec.length) html += countryGrid(ec);
          }
        }
        html += '</div></section>';
        app.innerHTML = html;
        return;
      }

      if (cfg.showTiles && !searching) html += regionTiles(d);
      html += '<div data-svo-grid-top></div>';

      if (searching) {
        var cs = sortItems(d.countries.filter(function (c) { return matchQ(c.name) || matchQ(c.region); }), state.sort);
        var rs = d.regionals.filter(function (r) { return matchQ(r.name) || matchQ(r.region); });
        html += '<section class="block"><div class="wrap">' +
          '<div class="sec-head"><div><div class="kicker">Search</div><h2>Results for \u201c' + esc(state.query) + '\u201d</h2></div>' +
          '<button type="button" class="chip" data-clear>Clear search \u2715</button></div>';
        if (cs.length + rs.length === 0) {
          html += '<div class="empty">' + ICON.search +
            '<h3>No destinations match \u201c' + esc(state.query) + '\u201d.</h3>' +
            '<p>Try a country name like \u201cJapan\u201d, or browse by region.</p>' +
            '<button type="button" data-clear>Browse all destinations</button></div>';
        } else {
          if (rs.length) html += '<div class="result-meta" style="padding-top:0;margin-bottom:12px"><b>' + rs.length + '</b> regional plan' + (rs.length > 1 ? "s" : "") + '</div>' +
            '<div class="rgrid" style="margin-bottom:30px">' + rs.map(regionalCard).join("") + '</div>';
          if (cs.length) html += '<div class="result-meta" style="padding-top:0;margin-bottom:12px"><b>' + cs.length + '</b> ' + (cs.length > 1 ? "destinations" : "destination") + '</div>' + countryGrid(cs);
        }
        html += '</div></section>';
      } else {
        var reg = state.region;
        // Popular
        if ((reg === "all" || reg === "popular") && d.popular.length) {
          var popItems = reg === "popular" ? d.popular : d.popular.slice(0, cfg.cardStyle === "flag" ? 10 : 8);
          html += '<section class="block scroll-anchor"><div class="wrap">' +
            secHead("Most loved", "Popular destinations", "The eSIMs travellers reach for first.", d.popular.length + " destinations") +
            countryGrid(popItems) + '</div></section>';
        }
        // Regional plans
        if (cfg.showRegional && (reg === "all" || reg === "regional") && d.regionals.length) {
          html += '<section class="block scroll-anchor" id="regional" style="background:var(--paper);border-top:1px solid var(--line);border-bottom:1px solid var(--line)"><div class="wrap">' +
            secHead("One eSIM, many borders", "Multi-country regional plans",
                    "Crossing borders? These cover several countries on a single plan — no swapping.", d.regionals.length + " plans") +
            '<div class="rgrid">' + sortItems(d.regionals, state.sort).map(regionalCard).join("") + '</div></div></section>';
        }
        // Per-continent
        html += '<div id="destinations">';
        var shown = d.regionsPresent.filter(function (r) { return reg === "all" || reg === r; });
        shown.forEach(function (r, idx) {
          var items = sortItems(d.byRegion[r] || [], state.sort);
          if (!items.length) return;
          var paper = (idx % 2 === 1 && reg === "all");
          html += '<section class="block scroll-anchor"' + (paper ? ' style="background:var(--paper);border-top:1px solid var(--line);border-bottom:1px solid var(--line)"' : '') + '>' +
            '<div class="wrap">' + secHead(r, r, null, items.length + " destinations", (regionMeta[r] && regionMeta[r].color) || "var(--accent-ink)") +
            countryGrid(items) + '</div></section>';
        });
        html += '</div>';
      }

      app.innerHTML = html;
    }

    /* ---------- scrolling ---------- */
    function stickyTop() {
      var v = getComputedStyle(root).getPropertyValue("--svo-sticky-top").trim();
      var n = parseInt(v, 10); return isNaN(n) ? 70 : n;
    }
    function scrollToGrid() {
      var anchor = app.querySelector("[data-svo-grid-top]") || app;
      var y = anchor.getBoundingClientRect().top + window.scrollY - (stickyTop() + 50);
      window.scrollTo({ top: y, behavior: "smooth" });
    }

    /* ---------- events (delegated) ---------- */
    function setRegion(r) { state.region = r; state.query = ""; searchInputs.forEach(function (i) { i.value = ""; }); render(); setTimeout(scrollToGrid, 30); }

    root.addEventListener("click", function (e) {
      var favBtn = e.target.closest("[data-fav]");
      if (favBtn) {
        e.preventDefault(); e.stopPropagation();
        var h = favBtn.getAttribute("data-fav");
        if (state.favs[h]) { delete state.favs[h]; favBtn.innerHTML = ICON.heart; }
        else { state.favs[h] = true; favBtn.innerHTML = ICON.heartFill; }
        return;
      }
      var regBtn = e.target.closest("[data-region]");
      if (regBtn) { e.preventDefault(); setRegion(regBtn.getAttribute("data-region")); return; }
      if (e.target.closest("[data-clear]")) { e.preventDefault(); state.query = ""; searchInputs.forEach(function (i) { i.value = ""; }); render(); return; }
      var cta = e.target.closest("[data-svo-cta]");
      if (cta) {
        e.preventDefault();
        var top = root.getBoundingClientRect().top + window.scrollY - 10;
        window.scrollTo({ top: top, behavior: "smooth" });
        setTimeout(function () { var inp = root.querySelector(".bigsearch input"); if (inp) inp.focus(); }, 450);
      }
    });

    var typingTimer;
    function onSearch(val, doScroll) {
      state.query = val;
      searchInputs.forEach(function (i) { if (i.value !== val) i.value = val; });
      clearTimeout(typingTimer);
      typingTimer = setTimeout(function () { render(); if (doScroll) scrollToGrid(); }, 120);
    }
    searchInputs.forEach(function (inp) {
      inp.addEventListener("input", function () { onSearch(inp.value, false); });
      inp.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); render(); scrollToGrid(); } });
    });

    // hero "popular" quick chips (rendered in Liquid with data-svo-quick)
    root.querySelectorAll("[data-svo-quick]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); state.region = "all"; onSearch(b.getAttribute("data-svo-quick"), true); });
    });

    if (sortSel) sortSel.addEventListener("change", function () { state.sort = sortSel.value; render(); });
    if (regionSel) regionSel.addEventListener("change", function () { setRegion(regionSel.value); });

    /* ---------- load ---------- */
    function fillHeroStats(d) {
      var rEl = root.querySelector("[data-svo-stat-regional]");
      var nEl = root.querySelector("[data-svo-stat-destinations]");
      if (state.scoped) {
        var regCount = (d.byRegion[state.scoped] || []).length;
        var regionalCount = d.regionals.filter(function (r) { return r.region === state.scoped; }).length;
        if (nEl) nEl.textContent = regCount;
        if (rEl) rEl.textContent = regionalCount;
      } else {
        // Full hub: "Destinations" stays the brand coverage figure from Liquid.
        if (rEl) rEl.textContent = d.regionals.length;
      }
    }

    function onData(parsed) {
      state.data = parsed;
      if (fallback) fallback.hidden = true;
      fillHeroStats(derived());
      render();
    }
    function onError(err) {
      if (app) app.innerHTML = "";   // leave the SEO/no-JS fallback visible
      if (console && console.warn) console.warn("[SIMOVO destinations] feed unavailable:", err && err.message);
    }
    var getJSON = function (url) {
      return fetch(url, { headers: { Accept: "application/json" } })
        .then(function (res) { if (!res.ok) throw new Error("HTTP " + res.status + " " + url); return res.json(); })
        .then(function (j) { return (j && j.products) || []; });
    };

    if (cfg.countriesUrl && cfg.regionalUrl) {
      // Collection-based mode (recommended): one feed of countries, one of regional plans.
      Promise.all([getJSON(cfg.countriesUrl), getJSON(cfg.regionalUrl)])
        .then(function (feeds) {
          if (!feeds[0].length && !feeds[1].length) throw new Error("both feeds empty");
          onData(parseCollections(feeds[0], feeds[1]));
        })
        .catch(onError);
    } else {
      // Legacy single-feed mode: tag-based regional detection.
      getJSON(cfg.productsUrl)
        .then(function (products) { if (!products.length) throw new Error("empty feed"); onData(parse(products)); })
        .catch(onError);
    }
  }

  function boot() { document.querySelectorAll(".svo-dest[data-svo-root]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener("shopify:section:load", function (e) {
    var r = e.target.querySelector ? e.target.querySelector(".svo-dest[data-svo-root]") : null;
    if (r) { r.__svoInit = false; init(r); }
  });
})();